import { useEffect, useState } from "react";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import NoData from "../../NoData";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Loading from "../../Loading";

export default function MasterSubject() {

    DataTable.use(DT);
    const [subject, setSubject] = useState({
        subject: "",
        status: 1,
        id: ""
    });

    const [subDetails, setSubDetails] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [show, setShow] = useState(false);
    const adminToken = localStorage.getItem("authAdminToken");
    const [loading, setLoading] = useState(true);

    const handleClose = () => setShow(false);

    // Show Details Section
    const fetchAllSubject = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllSubject`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });

        return response.json();
    };

    // Edit Section
    const handleEdit = async (event) => {
        event.preventDefault();

        if (!subject.subject) {
            toast.error("Subject field is required.");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/setSubject`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify(subject),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Subject update successfully!");
                setShowForm(false);
            } else {
                toast.error("Failed to update subject.");
            }

        } catch (error) {
            toast.error("An error occurred while adding the language. Please try again later.");
        }
    };

    // Delete Section
    const handleDelete = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/deleteSubject`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify({ id: subject.id }),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Subject delete successfully!");
                setShow(false);
            } else {
                toast.error("Failed to delete subject.");
            }

        } catch (error) {
            toast.error("An error occurred while adding the language. Please try again later.");
        }
    };

    useEffect(() => {
        fetchAllSubject().then((res) => {
            if (res.status) {
                setLoading(false);
                setSubDetails(res?.subjects);
            } else {
                toast.error("Failed to load subject. Please try again.");
            }
        }).catch((err) => {
            toast.error("Unable to fetch subject at the moment.");
        });
    }, [showForm, show]);

    function editSubDetails(subject) {
        setSubject(subject);
        setShowForm(true);
    }

    function deleteSubject(subject) {
        setSubject(subject);
        setShow(true)
    }

    return (
        <>

            {loading ?

                <Loading />
                :
                <>
                    {showForm ? (
                        <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }}>
                            {/* Toast container */}
                            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
                            <div className="app-ecommerce">
                                <div className="row">
                                    <div className="col-12 col-lg-8">
                                        <div className="card mb-6">
                                            <div className="card-header">
                                                <h5 className="card-tile mb-0">Add Subject Master</h5>
                                            </div>
                                            <div className="card-body">

                                                <form onSubmit={(event) => { handleEdit(event) }}>
                                                    <div className="row gx-5 mb-5">
                                                        <div className="col">
                                                            <div className="form-floating form-floating-outline">
                                                                <input type="text" className="form-control" value={subject.subject} onChange={(event) => { setSubject({ ...subject, subject: event.target.value }) }} placeholder="Subject" />
                                                                <label htmlFor="subject">Subject</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row gx-5 mb-5">
                                                        <div className="col">
                                                            <div className="form-floating form-floating-outline">
                                                                <select className="form-select form-select-sm" id="status" value={subject.status} onChange={(event) => setSubject({ ...subject, status: parseInt(event.target.value) })}>
                                                                    <option value="">Select Status</option>
                                                                    <option value={1}>Active</option>
                                                                    <option value={0}>Inactive</option>
                                                                </select>
                                                                <label htmlFor="status">Status</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 d-flex gap-4 mx-4">
                                                        <button type="submit" className="btn btn-primary">Update</button>
                                                        <button type="submit" className="btn btn-primary" onClick={() => { setShowForm(false) }}>Cancel</button>
                                                    </div>

                                                </form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 25em" }}>
                            {/* Toast container */}
                            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

                            <div className="card">

                                <div className="d-flex justify-content-between">
                                    <div className="card-header ">
                                        <h5 className="card-title mb-0">Subject Master</h5>
                                    </div>
                                    <Link to="/admin/addsubject" className="card-header">
                                        <button className="btn btn-primary"> Add Subject</button>
                                    </Link>
                                </div>

                                {subDetails.length > 0 ?
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <DataTable
                                                data={subDetails.map((subject, index) => [
                                                    index + 1,
                                                    subject.subject,
                                                    subject.status
                                                        ? '<div class="text-success">Active</div>'
                                                        : '<div class="text-danger">Inactive</div>',
                                                    JSON.stringify(subject)
                                                ])}
                                                slots={{
                                                    3: (data) => {

                                                        return <div className="d-flex gap-3" >
                                                            <button class="btn btn-outline-primary btn-icon border-none" onClick={() => { editSubDetails(JSON.parse(data)) }}>
                                                                <MdModeEdit style={{ color: "#666cff", fontSize: "30px" }} />
                                                            </button>
                                                            <button class="btn btn-outline-danger btn-icon border-none" onClick={() => { deleteSubject(JSON.parse(data)) }}>
                                                                <MdDelete style={{ color: "#fc2929ff", fontSize: "30px" }} />
                                                            </button>
                                                        </div>;
                                                    }
                                                }}
                                                className="display"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Subject</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                            </DataTable>
                                        </div>
                                    </div>

                                    :

                                    <NoData />
                                }
                            </div>
                        </div>
                    )}
                </>

            }

            {/* modal */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Are you sure you want to delete this item?
                </Modal.Body>

                <div className="col-md-11 my-4 mx-5">
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-danger mt-3" onClick={handleDelete}>
                        Delete
                    </button>
                </div>
            </Modal>

        </>

    )
}
